export default __webpack_public_path__ + "static/media/beer-tile.ca063d77.png";